// LocalStorage helpers: device id, settings and per-puzzle progress.

const DEVICE_KEY = "neji:device_id";
const SETTINGS_KEY = "neji:settings";
const PROGRESS_PREFIX = "neji:progress:";

const uuid = () => {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return "dev-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
};

export const getDeviceId = () => {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
};

export const loadSettings = () => {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) { /* ignore */ }
  return { lang: "tr", sound: true, animations: true };
};

export const saveSettings = (settings) => {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
};

export const loadProgress = (puzzleId) => {
  try {
    const raw = localStorage.getItem(PROGRESS_PREFIX + puzzleId);
    if (raw) return JSON.parse(raw);
  } catch (e) { /* ignore */ }
  return null;
};

export const saveProgress = (puzzleId, progress) => {
  try {
    localStorage.setItem(PROGRESS_PREFIX + puzzleId, JSON.stringify(progress));
  } catch (e) { /* ignore */ }
};

export const clearProgress = (puzzleId) => {
  localStorage.removeItem(PROGRESS_PREFIX + puzzleId);
};
